import { useAppSelector } from '../../../store/hooks';
import UserAccount from '../../Features/UserAccount';
import { selectUser } from '../../slices/Auth';

export const UserMenu = () => {
  const user = useAppSelector(selectUser);

  return <UserAccount user={user} />;
};
